import { useEffect } from "react";
import { Clock, Play, Pause, X } from "lucide-react";
import { Slider } from "@/components/ui/slider";

const hm = (m) => { const x = ((Math.round(m) % 1440) + 1440) % 1440; return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(x % 60).padStart(2, "0")}`; };

export const TimeBar = ({ range, at, setAt, playing, setPlaying }) => {
  const [lo, hi] = range;
  useEffect(() => {
    if (!playing) return undefined;
    const t = setInterval(() => setAt((v) => (v + 5 > hi ? lo : v + 5)), 400);
    return () => clearInterval(t);
  }, [playing, lo, hi, setAt]);

  if (at == null)
    return (
      <button onClick={() => setAt(lo)} data-testid="timebar-open-button"
        className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium border backdrop-blur-md bg-white/95 text-slate-700 border-slate-200 hover:bg-slate-100 transition-colors">
        <Clock className="w-4 h-4" /> Personal por hora
      </button>
    );
  return (
    <div className="flex items-center gap-3 bg-white/95 backdrop-blur-md border border-sky-500/40 rounded-xl px-3 py-2 w-[520px] max-w-[90vw] rise" data-testid="timebar">
      <button onClick={() => setPlaying(!playing)} className="w-8 h-8 rounded-full bg-sky-500 text-slate-950 flex items-center justify-center shrink-0" data-testid="timebar-play-button">
        {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4 ml-0.5" />}
      </button>
      <span className="font-mono text-sm font-bold text-slate-900 w-12" data-testid="timebar-time">{hm(at)}</span>
      <Slider value={[at]} min={lo} max={hi} step={5} onValueChange={([v]) => setAt(v)} className="flex-1" data-testid="timebar-slider" />
      <span className="font-mono text-[0.625rem] text-slate-500">{hm(lo)}–{hm(hi)}</span>
      <button onClick={() => { setPlaying(false); setAt(null); }} className="text-slate-500 hover:text-slate-900" data-testid="timebar-close-button"><X className="w-4 h-4" /></button>
    </div>
  );
};

export const staffAt = (points, at) => {
  if (at == null) return points;
  return points.map((p) => {
    const groups = {};
    const units = {};
    const items = [];
    const seen = new Set();
    (p.slots || []).filter((s) => s.start <= at && at < s.end).forEach((s) => {
      if (seen.has(s.uid)) return;
      seen.add(s.uid);
      groups[s.g] = (groups[s.g] || 0) + s.persons;
      (units[s.g] = units[s.g] || []).push(s.uid);
      if (s.t) items.push({ uid: s.uid, t: s.t, nota: s.nota || "", tip: s.tip || "" });
    });
    return { ...p, groups, units, items };
  }).filter((p) => Object.keys(p.groups).length);
};
